interface IAttentionIconProps {
  color?: string;
  className?: string;
}

const TicketIcon: React.FC<IAttentionIconProps> = ({ color, className }) => (
  <svg
    width="61"
    height="61"
    viewBox="0 0 61 61"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <g fill="none" fillRule="evenodd">
      <path
        d="m30.34 35.848 7.53 5.02-2.51 5.02 2.51 2.51 5.02-5.02 5.02-5.02-2.51-2.51-5.02 2.51-5.02-7.53 7.53-7.53-2.51-2.51-10.04 5.02-10.04-7.53-2.51 2.51 7.53 10.04-5.02 10.04 2.51 2.51 7.53-7.53zM.22 28.318v-10.04L17.79.708h10.04l32.63 32.63v10.04l-17.57 17.57H32.85L.22 28.319z"
        style={{ fill: `${color || 'var(--tt-dark-purple)'}` }}
      />
      <path
        style={{ fill: `${color || 'var(--tt-yellow)'}` }}
        d="m40.38 3.218 17.57 17.57-2.51 2.51-17.57-17.57z"
      />
    </g>
  </svg>
);

export default TicketIcon;
